'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var MagnifyingGlassIcon = function MagnifyingGlassIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === undefined ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['color', 'size', 'filled', 'className', 'children']);

  var classes = 'calcite-icon';
  if (className) classes += ' ' + className;

  if (size <= 16) {
    return _react2.default.createElement('svg', _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: '0 0 16 16',
      className: classes
    }), filled ? _react2.default.createElement('path', {
      d: 'M15.757 13.907l-3.009-3.01a.656.656 0 0 0-.925 0l-.009.008-1.229-1.229a5.905 5.905 0 1 0-.945.938l1.237 1.238a.65.65 0 0 0 .02.896l3.01 3.009a.652.652 0 0 0 .926 0l.924-.924a.653.653 0 0 0 0-.926zM9.006 9.004a4.25 4.25 0 1 1 0-6.01 4.25 4.25 0 0 1 0 6.01z'
    }) : _react2.default.createElement('path', {
      d: 'M15.805 13.918l-3.067-3.068a.668.668 0 0 0-.943 0l-.124.124-.968-.968a5.5 5.5 0 1 0-.69.69l.968.968-.13.129a.667.667 0 0 0 0 .943l3.068 3.067a.665.665 0 0 0 .943 0l.943-.942a.666.666 0 0 0 0-.943zM9.683 9.68A4.47 4.47 0 0 1 6.5 10.999a4.502 4.502 0 1 1 3.183-1.318zm4.708 5.18l-2.597-2.596.473-.473 2.595 2.598z'
    }));
  }

  if (size <= 24) {
    return _react2.default.createElement('svg', _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: '0 0 24 24',
      className: classes
    }), filled ? _react2.default.createElement('path', {
      d: 'M23.707 20.878l-4.515-4.514a1 1 0 0 0-1.414 0l-.018.018-1.747-1.748a9.03 9.03 0 1 0-1.42 1.41l1.757 1.755a.997.997 0 0 0 .014 1.393l4.514 4.516a1.001 1.001 0 0 0 1.414 0l1.415-1.416a1 1 0 0 0 0-1.414zM9 16a7 7 0 1 1 7-7 7.008 7.008 0 0 1-7 7z'
    }) : _react2.default.createElement('path', {
      d: 'M23.764 21.476l-5.24-5.24a.81.81 0 0 0-1.144 0l-.218.219-1.324-1.324.205-.206a8.503 8.503 0 1 0-1.118 1.118l.205-.205 1.325 1.324-.219.218a.81.81 0 0 0 0 1.145l5.24 5.238a.808.808 0 0 0 1.143 0l1.145-1.143a.811.811 0 0 0 0-1.144zM1.9 9.5a7.6 7.6 0 1 1 7.6 7.6 7.6 7.6 0 0 1-7.6-7.6zm20.148 13.42l-4.97-4.968.874-.873 4.97 4.968z'
    }));
  }

  return _react2.default.createElement('svg', _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: '0 0 32 32',
    className: classes
  }), filled ? _react2.default.createElement('path', {
    d: 'M30.386 27.555l-7.073-7.07a1 1 0 0 0-1.414 0l-1.45-1.45a11 11 0 1 0-1.413 1.414l1.45 1.45a1 1 0 0 0 0 1.414l7.07 7.072a1.002 1.002 0 0 0 1.415 0l1.415-1.416a1 1 0 0 0 0-1.414zm-24.75-9.191a9 9 0 1 1 12.728 0 9 9 0 0 1-12.728 0z'
  }) : _react2.default.createElement('path', {
    d: 'M29.95 27.121l-7.071-7.07a1 1 0 0 0-1.414 0l-.354.353-.865-.866.333-.333a10.5 10.5 0 1 0-1.375 1.375l.334-.334.866.865-.354.354a1 1 0 0 0 0 1.414l7.071 7.07a1 1 0 0 0 1.414 0l1.415-1.414a1 1 0 0 0 0-1.414zM5.712 19.29a9.6 9.6 0 1 1 13.576 0 9.6 9.6 0 0 1-13.576 0zm22.116 9.954l-7.07-7.071 1.414-1.415 7.07 7.072z'
  }));
};

exports.default = MagnifyingGlassIcon;